<template>
  <div
      v-if="isOpen"
      class="modal fade show"
      aria-labelledby="addNewCardTitle"
      style="display: block; background: #1c1d1c33"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div
                class="d-flex justify-content-between px-1 my-1 align-item-center"
            >
              <h1 class="mb-0">{{ modalTitle }}</h1>
              <button
                  @click="toggleModal"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
        <hr class="mt-0"/>

        <div class="pb-2">
          <!-- form -->
          <vForm @submit="submit" :validation-schema="schema">
            <div class="row gy-2 px-2">
              <div class="col-12">
                <label class="form-label" for="name">Cost Centre Name</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="name"
                      v-model="formData.name"
                      class="form-control add-credit-card-mask"
                      placeholder="Cost Centre Name"
                  />
                  <ErrorMessage
                      name="name"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="short_name">Cost Centre Short Name</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="short_name"
                      v-model="formData.short_name"
                      class="form-control add-credit-card-mask"
                      placeholder="Cost Centre Short Name"
                  />
                  <ErrorMessage
                      name="short_name"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="code">Cost Centre ID</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="code"
                      v-model="formData.code"
                      class="form-control add-credit-card-mask"
                      placeholder="Cost Centre ID"
                  />
                  <ErrorMessage
                      name="code"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="description">Cost Centre Description</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="description"
                      v-model="formData.description"
                      class="form-control add-credit-card-mask"
                      placeholder="Cost Centre ID"
                  />
                  <ErrorMessage
                      name="description"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="status">Status</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="status"
                      v-model="formData.status"
                      class="form-control add-credit-card-mask"
                      placeholder="Cost Centre ID"
                  />
                  <ErrorMessage
                      name="status"
                      class="invalid-feedback d-block qcont"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 text-center">
              <hr class="mt-2"/>
              <button
                  :disabled="loading"
                  type="submit"
                  class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light"
              >
                <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm text-light"
                    role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
                Submit
              </button>
              <button @click.prevent="toggleModal"
                      class="btn btn-outline-secondary mt-1 waves-effect"
              >
                Cancel
              </button>
            </div>
          </vForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";

const isOpen = ref(false);
const loading = ref(false);
const emit = defineEmits(['onSubmitForm', 'onCloseCostCentreModal'])

const props = defineProps({
  formData: Object,
  showParent: {
    type: Boolean,
    default: false
  },
  costCentre: {},
  modalTitle: {
    type: String,
    default: 'Add Cost Centre'
  },
});

const schema = {
  name: 'required|min:3|max:100',
};

function submit() {
  emit('onSubmitForm');
}

function toggleModal() {
  if (isOpen.value) {
    emit("onCloseCostCentreModal");
  }
  isOpen.value = !isOpen.value;
}

defineExpose({
  toggleModal
})
</script>
